import { Component } from '@angular/core';
import {RouterLink, RouterOutlet} from "@angular/router";
import {FormInputTextDirective} from "../../core/directives/form-input-text.directive";
import {FormLabelDirective} from "../../core/directives/form-label.directive";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [
    RouterOutlet,
    FormInputTextDirective,
    FormLabelDirective,
    FormsModule,
    RouterLink
  ],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.css'
})
export class AuthComponent {

}
